import angular from 'angular';

let inject = ['$scope', '$uibModalInstance', 'product'];

class ModalQuantityCartController {
    constructor($scope, $uibModalInstance, product) {
        this.$scope = $scope;
        this.product = angular.copy(product);
        this.$uibModalInstance = $uibModalInstance;
        this.factorItem = (this.product.factor < this.product.factor_pedido)?this.product.factor_pedido:this.product.factor;
        this.itemQuantityToAdd = (this.product.factor > this.product.cantidad_minima) ? parseFloat(this.product.factor) : parseFloat(this.product.cantidad_minima);

        this.user = {};
    }

    increaseItemQuantityToAdd() {
        this.itemQuantityToAdd = parseFloat(this.itemQuantityToAdd)  + ( (parseFloat(this.factorItem)>0)?parseFloat(this.factorItem):1 ); 
    }

    decreaseItemQuantityToAdd() {

        if (this.itemQuantityToAdd > 1){
            this.itemQuantityToAdd-= (this.factorItem>0)?this.factorItem:1;
        }
        if(this.product.cantidad_minima>0 && this.itemQuantityToAdd < this.product.cantidad_minima){
            if(this.factorItem > this.product.cantidad_minima){
                this.itemQuantityToAdd=this.factorItem;
            }else{
                this.itemQuantityToAdd=this.product.cantidad_minima;
            }
        }else if(this.product.cantidad_minima<0 && this.itemQuantityToAdd < this.product.cantidad_minima){
            this.itemQuantityToAdd=1;
        }
    }


    addItemToCart(product, quantity) {
        this.$uibModalInstance.close({product: product, quantity: quantity});
    }

    cancel() {
        this.$uibModalInstance.dismiss('cancel');
    }
}

ModalQuantityCartController.$inject = inject;

export default ModalQuantityCartController;



/** WEBPACK FOOTER **
 ** ./www/components/catalog/modal-quantity-cart/modal-quantity-cart.controller.js
 **/